import { Typography } from "antd"
import { MasterConfigs } from "../../../interfaces/entity"
import RenderForm from "../../../components/Forms/Form"
import React, { forwardRef, useEffect, useImperativeHandle } from "react"
import { useDispatch } from "react-redux"
import { getData } from "../../../actions/apiCall"

const { Text } = Typography

interface Props {
    onLoadingChange?: (loading: boolean) => void;
}

const PointOfContact = forwardRef((props: Props, ref) => {
    const { onLoadingChange } = props;
    const [form, setForm] = React.useState<any>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const id = new URLSearchParams(window.location.search).get('vendor') || ''
    const submitPromiseRef = React.useRef<{ resolve?: (value: any) => void; reject?: (reason?: any) => void }>({});
    const [vendorId, setVendorId] = React.useState<string>('');
    const dispatch = useDispatch();
    const [isDisabled, setDisabled] = React.useState<any>(false);

    useEffect(() => {
        if (vendorId) {
            getDoccuments()
        }
    }, [vendorId])

    const getDoccuments = async () => {
        try {
            const resData = await dispatch(getData(`/v1/vendor/${vendorId}`));
            if (resData) {
                setDisabled(resData.data.msaSigned || resData.data.ndaSigned)
            } else {
                setDisabled(false)
            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }
    }

    const getQueryStep = () => {
        const params = new URLSearchParams(location.search);
        const vendorId = params.get('vendor')
        setVendorId(vendorId || '')
        return vendorId
    };

    useEffect(() => {
        getQueryStep()
    }, [location.search]);


    useEffect(() => {
        onLoadingChange?.(loading);
    }, [loading, onLoadingChange]);


    useImperativeHandle(ref, () => ({
        submitStep: () => {
            return new Promise((resolve, reject) => {
                submitPromiseRef.current = { resolve, reject };
                form.submit();
            });
        }
    }));

    const config: MasterConfigs = {
        api: () => "/v1/vendor",
        modalTitle: () => "Vendor Registration",
        afterSubmit: (res: any) => {
            submitPromiseRef.current?.resolve?.(res);
            setLoading(false);
        },
        onError: (error: any) => {
            submitPromiseRef.current?.reject?.(error);
            setLoading(false);
        },
        getFormColumns: () => [
            {
                type: 'custom',
                formItem: () => <div className="flex flex-col">
                    <Text strong>Point of Contact</Text>
                    <Text type="secondary" className="-mt-1">Recommend at least two points of contact.</Text>
                </div>,
            },
            {
                name: 'pointOfcontact',
                type: 'form',
                span: 24,
                form: [
                    {
                        label: 'First Name',
                        name: 'firstName',
                        type: 'text',
                        placeholder: 'Enter First Name',
                        rules: [{ required: true, message: 'First Name is required' }],
                        span: 8,
                    },
                    {
                        label: 'Last Name',
                        name: 'lastName',
                        type: 'text',
                        placeholder: 'Enter Last Name',
                        rules: [{ required: true, message: 'Last Name is required' }],
                        span: 8,
                    },
                    {
                        label: 'Designation',
                        name: 'designation',
                        type: 'text',
                        placeholder: 'Enter Designation',
                        rules: [{ required: true, message: 'Designation is required' }],
                        span: 8,
                    },
                    {
                        label: 'Email',
                        name: 'email',
                        type: 'text',
                        placeholder: 'Enter Email',
                        rules: [{ required: true, message: 'Email is required' },
                        { type: 'email', message: 'Please enter a valid email' }],
                        span: 8,
                    },
                    {
                        label: 'Phone',
                        name: 'phone',
                        type: 'text',
                        span: 8,
                        inputProps: {
                            onKeyPress: (e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }
                        },
                        placeholder: 'Enter Phone',
                        rules: [{ required: true, message: 'Phone is required' },
                        {
                            pattern: /^\+?[0-9]{10,15}$/,
                            message: 'Enter a valid phone number (10–15 digits)',
                        }
                        ],
                    },
                    {
                        type: 'custom',
                        span: 8,
                    },
                    {
                        label: 'Alternate Email',
                        name: 'alternateEmail',
                        type: 'text',
                        placeholder: 'Enter Email',
                        rules: [{ type: 'email', message: 'Please enter a valid email' }],
                        span: 8,
                    },
                    {
                        label: 'Alternate Phone',
                        name: 'alternatePhone',
                        type: 'text',
                        span: 8,
                        inputProps: {
                            onKeyPress: (e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }
                        },
                        placeholder: 'Enter Phone',
                        rules: [{
                            pattern: /^\+?[0-9]{10,15}$/,
                            message: 'Enter a valid phone number (10–15 digits)',
                        }]
                    }
                ]
            }
        ]
    }
    return <RenderForm config={config} formInstance={(form) => setForm(form)} setLoading={(e) => setLoading(e)} id={vendorId}
        isView={isDisabled} />
})

export default PointOfContact